import { apiClient } from '../../gateways/api'

export { patchProjectmelding }

const patchProjectmelding = async ({ id }: { id: string }): Promise<void> => {
  const { data } = await apiClient({
    url: `/rest/projectmelding/${id}`,
    method: 'PATCH',
    data: {
      status: {
        code: 3010,
      },
    },
  })

  return data
}
